var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiveOrderTableIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 16.667 6.25 13.542Q6.438 13.062 6.854 12.781Q7.271 12.5 7.792 12.5H9.125V9.146Q5.958 9.042 3.812 8.208Q1.667 7.375 1.667 6.25Q1.667 5.042 4.104 4.188Q6.542 3.333 10 3.333Q13.458 3.333 15.896 4.188Q18.333 5.042 18.333 6.25Q18.333 7.375 16.188 8.208Q14.042 9.042 10.875 9.146V12.5H12.208Q12.708 12.5 13.135 12.781Q13.562 13.062 13.75 13.542L15 16.667H13.25L12.292 14.25H7.708L6.75 16.667ZM10 7.417Q11.917 7.417 13.656 7.094Q15.396 6.771 16.271 6.25Q15.396 5.729 13.656 5.406Q11.917 5.083 10 5.083Q8.083 5.083 6.344 5.406Q4.604 5.729 3.729 6.25Q4.604 6.771 6.344 7.094Q8.083 7.417 10 7.417ZM10 6.25Q10 6.25 10 6.25Q10 6.25 10 6.25Q10 6.25 10 6.25Q10 6.25 10 6.25Q10 6.25 10 6.25Q10 6.25 10 6.25Q10 6.25 10 6.25Q10 6.25 10 6.25Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveOrderTableIcon);
export default __webpack_public_path__ + "static/media/LiveOrderTableIcon.cfc791c6.svg";
export { ForwardRef as ReactComponent };